import React from "react";
import Banner from "./Home/banner";
import Feature from "./Home/feature";
import Proccess from "./Home/proccess";
import WhyUs from "./Home/whyus";
import TrustUs from "./Home/trustus";
import Offering from "./Home/offering";
import Faq from "./Home/faq";
import "./Home/index.css";
import StatsSection from "./Home/StatsSection";
import ClientPortfolio from "./Home/ClientPortfolio";

function Home() {
  return (
    <div className="w-full overflow-x-hidden">
      <Banner />
      <StatsSection />
      <Proccess />
      <Feature />
      <ClientPortfolio />
      <WhyUs />
      <TrustUs />
      <Offering />
      <Faq />
    </div>
  );
}

export default Home;
